import { Skeleton } from "@/components/ui/skeleton";

const DiarySkeleton = () => (
  <div className="space-y-6 animate-in fade-in">
    {/* Header */}
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
      <div className="space-y-2">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-64" />
      </div>
      <div className="flex gap-2">
        <Skeleton className="h-9 w-24 rounded-full" />
        <Skeleton className="h-9 w-32 rounded-full" />
      </div>
    </div>

    <div className="grid lg:grid-cols-[280px_1fr] gap-6">
      {/* Calendar skeleton */}
      <div className="bg-card rounded-2xl p-5 shadow-card border border-border self-start">
        <div className="flex items-center justify-between mb-4">
          <Skeleton className="w-6 h-6 rounded" />
          <Skeleton className="h-4 w-32" />
          <Skeleton className="w-6 h-6 rounded" />
        </div>
        <div className="grid grid-cols-7 gap-1">
          {Array.from({ length: 7 }).map((_, i) => (
            <Skeleton key={`wk-${i}`} className="h-4 w-8 mx-auto" />
          ))}
          {Array.from({ length: 35 }).map((_, i) => (
            <Skeleton key={`d-${i}`} className="w-8 h-8 rounded-full mx-auto" />
          ))}
        </div>
      </div>

      {/* Right content skeleton */}
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Skeleton className="w-8 h-8 rounded" />
            <div className="space-y-1">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-3 w-36" />
            </div>
          </div>
          <Skeleton className="h-10 w-40 rounded-lg" />
        </div>

        {/* Calories card */}
        <div className="bg-card rounded-2xl p-5 shadow-card border border-border space-y-3">
          <div className="flex items-center gap-3">
            <Skeleton className="w-9 h-9 rounded-xl" />
            <div className="space-y-1">
              <Skeleton className="h-3 w-28" />
              <Skeleton className="h-7 w-24" />
            </div>
          </div>
          <Skeleton className="h-3 w-full rounded-full" />
          <Skeleton className="h-10 w-full rounded-xl" />
          <div className="grid grid-cols-3 gap-3">
            {[1, 2, 3].map(i => (
              <Skeleton key={i} className="h-16 rounded-xl" />
            ))}
          </div>
        </div>

        {/* Meals skeleton */}
        <div className="bg-card rounded-2xl p-5 shadow-card border border-border space-y-3">
          <Skeleton className="h-5 w-32" />
          {[1, 2, 3].map(i => (
            <Skeleton key={i} className="h-20 w-full rounded-xl" />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default DiarySkeleton;
